(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopMq = window.matchMedia('(min-width: 750px)');

    function posterFromImage(img) {
      if (!img || img.tagName !== 'IMG') {
        return '';
      }
      return img.currentSrc || img.src || '';
    }

    function bindTile(mediaElement) {
      const videoUrl = mediaElement.dataset.videoUrl;
      if (!videoUrl || mediaElement.querySelector('.benefits__video')) {
        return;
      }

      const image = mediaElement.querySelector('.benefits__image');
      const video = document.createElement('video');
      video.className = 'benefits__video';
      video.setAttribute('aria-hidden', 'true');
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'none';
      video.dataset.src = videoUrl;

      const setPoster = () => {
        const p = posterFromImage(image);
        if (p) {
          video.poster = p;
        }
      };
      setPoster();
      if (image && image.tagName === 'IMG' && !image.complete) {
        image.addEventListener('load', setPoster, { once: true });
      }

      mediaElement.append(video);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }
            const v = entry.target;
            if (!v.src && v.dataset.src) {
              v.src = v.dataset.src;
              v.load();
            }
            observer.unobserve(v);
          });
        },
        { rootMargin: '200px 0px' }
      );
      observer.observe(video);

      mediaElement.addEventListener('mouseenter', () => {
        if (!desktopMq.matches) {
          return;
        }
        setPoster();
        if (!video.src && video.dataset.src) {
          video.src = video.dataset.src;
          video.load();
        }
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
        mediaElement.classList.add('is-video-visible');
      });

      mediaElement.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
        mediaElement.classList.remove('is-video-visible');
      });
    }

    function initBenefitsSection(sectionRoot) {
      if (!sectionRoot) {
        return;
      }
      sectionRoot.querySelectorAll('.benefits__media[data-video-url]').forEach(bindTile);
    }

    function initAll() {
      document.querySelectorAll('section.benefits.full-width').forEach(initBenefitsSection);
    }

    initAll();

    document.addEventListener('shopify:section:load', (event) => {
      const el = event.target;
      if (!el || typeof el.querySelector !== 'function') {
        return;
      }
      const root =
        el.querySelector('section.benefits.full-width') ||
        (el.matches?.('section.benefits.full-width') ? el : null);
      if (root) {
        initBenefitsSection(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
